import React from "react";
import { InvalidReturnAddressAlert } from "./Process/InvalidReturnAddressAlert/InvalidReturnAddressAlert";
import useStorePersistance from "./Process/StorePersistance/useStorePersitance";


export const RouteProcessManager = () => {
  useStorePersistance()
  return (
    <>
      <InvalidReturnAddressAlert />
    </>
  );
};
